/**
 * Auth Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.4
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagDetailsResponse } from './tagDetailsResponse';

export interface ManagementClientTagResponse {
    id?: string;
    priority?: number;
    sentiment?: boolean;
    realTime?: boolean;
    realTimeEmails?: Array<string>;
    tagType?: ManagementClientTagResponse.TagTypeEnum;
    tagId?: string;
    colorCode?: string;
    details?: Array<TagDetailsResponse>;
    clientId?: string;
    aiPrompt?: string;
}
export namespace ManagementClientTagResponse {
    export type TagTypeEnum = 'CLIPPING' | 'TRANSCRIPTION' | 'CONTRACT_NOTICES';
    export const TagTypeEnum = {
        CLIPPING: 'CLIPPING' as TagTypeEnum,
        TRANSCRIPTION: 'TRANSCRIPTION' as TagTypeEnum,
        CONTRACTNOTICES: 'CONTRACT_NOTICES' as TagTypeEnum
    };
}